import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kve-top-left',
  templateUrl: './top-left.component.html',
  styleUrls: ['./top-left.component.scss']
})
export class TopLeftComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
